import moment from 'moment';
const serverDateFormat = 'YYYY-MM-DD HH:mm:ss';
/** Format a datetime */
const format_date = (datetime, format, fromFormat = 'YYYY-MM-DD HH:mm:ss') => moment(datetime, fromFormat).locale('da').format(format);

/** Return a human-friendly formatted date with time */
const humanize_datetime = datetime => moment(datetime).locale(moment_locale).format('LLL');

/** Return a human-friendly formatted date with time */
const humanize_timestamp = timestamp => moment.unix(timestamp).locale(moment_locale).format('LLLL');

/** Return a human-friendly formatted date */
const humanize_date = datetime => moment(datetime).locale(moment_locale).format('LL');

/** Return a human-friendly formatted date with day */
const humanize_dateday = datetime => moment(datetime).locale(moment_locale).format('dddd, Do MMMM');

/** Return a just the day of the month */
const humanize_day = datetime => moment(datetime).locale(moment_locale).format('D');

/** Return a just the day of the week */
const humanize_day_of_week = datetime => moment(datetime).locale(moment_locale).format('dddd');

/** Return a date in a long format ie Wednesday August 3rd 2022 */
const humanize_date_long = datetime => moment(datetime).locale(moment_locale).format('dddd MMMM Do YYYY');

/** Return a date time in a long format ie Wednesday 11 August 2022, 10:40 */
const humanize_datetime_long = datetime => moment(datetime).locale(moment_locale).format('dddd D MMMM YYYY, HH:mm')

/** Return a date in following format ie February, 2025 */
const humanize_month_year_long = datetime => moment(datetime).locale(moment_locale).format('MMMM, YYYY')

/** Return the month in shorthand i.e JAN */
const humanize_month_short = datetime => moment(datetime).locale(moment_locale).format('MMM');

/** Return short year ie 21 instead of 2021 */
const humanize_year_short = datetime => moment(datetime).locale(moment_locale).format('YY');

/** Return a human-friendly formatted date with day */
const humanize_dateday_with_year = datetime => moment(datetime).locale(moment_locale).format('dddd, Do MMMM YYYY');

/** Return a human-friendly formatted time */
const humanize_time = datetime => moment(datetime).locale(moment_locale).format('LT');

/** Return the iso week number of the given date string */
const weekNumber = datetime => moment(datetime).locale(moment_locale).isoWeek()

/** Return the iso week day of the given date string */
const isoWeekday = datetime => moment(datetime).locale(moment_locale).isoWeekday()

/** Return the string with the first letter capitalized */
const capitalize = string => `${string.charAt(0).toUpperCase()}${string.slice(1)}`;

/** Return the string with all the letters in lowercase */
const lowercase = string => `${string}`.toLowerCase();

/** Return the string with all the letters in uppercase */
const uppercase = string => `${string}`.toUpperCase();

/** Return the Danish date formatted string */
const danish_date = date => moment(date).locale(moment_locale).format('DD.MM.YYYY');

/** Return the Danish date & time formatted string */
const danish_datetime = date => moment(date).locale(moment_locale).format('DD.MM.YYYY \\K\\l\\. H:mm');

const short_datetime = dt => moment(dt).locale(moment_locale).format('l LT');

/**
 * Return a human-friendly formatted interval between two dates
 */
const datetime_span_to = (start, end) => {
    let start_date = moment(start, serverDateFormat);
    let end_date = moment(end, serverDateFormat);

    if (end_date.diff(start_date, 'days') > 0) {
        return start_date.locale(moment_locale).format('LL') + ", " + start_date.format("HH:mm") + " " + trans('global.to') + "<br/> " + end_date.locale(moment_locale).format('LL') + ", "+ end_date.format('HH:mm');
    }

    return start_date.locale(moment_locale).format('LL') + ", " + start_date.format("HH:mm") + " " + trans('global.to') + " " + end_date.format('HH:mm');
}

/**
 * Return the string truncated to a certain value
 */
const truncate = (value, limit) => {
    if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...';
    }
    return value
}

const file_size = (size, decimals = 3) => {
    size = parseInt(size);

    if (size === 0) return '0 Bytes';

    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(size) / Math.log(k));

    return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const format_number = (num) => {
    if (Intl && Intl.NumberFormat) {
        return (new Intl.NumberFormat()).format(num);
    }

    return num;
}


/** All Filters */
const filters = {
    format_date,
    humanize_datetime,
    humanize_timestamp,
    humanize_date,
    humanize_dateday,
    humanize_day,
    humanize_day_of_week,
    humanize_date_long,
    humanize_datetime_long,
    humanize_month_year_long,
    humanize_month_short,
    humanize_year_short,
    humanize_dateday_with_year,
    humanize_time,
    weekNumber,
    isoWeekday,
    capitalize,
    lowercase,
    uppercase,
    danish_date,
    danish_datetime,
    datetime_span_to,
    truncate,
    file_size,
    format_number,
    short_datetime,
}

const globalFilters = {
    install: function(vueInstance) {
        if (vueInstance.version && vueInstance.version.startsWith('2.')) {
            // Vue 2 integration
            vueInstance.prototype.$filters = vueInstance.prototype.$filters || {};
            vueInstance.prototype.$filters = Object.assign(vueInstance.prototype.$filters, filters);
        } else if (vueInstance.config && vueInstance.config.globalProperties) {
            // Vue 3 integration
            vueInstance.config.globalProperties.$filters = vueInstance.config.globalProperties.$filters || {};
            vueInstance.config.globalProperties.$filters = Object.assign(vueInstance.config.globalProperties.$filters, filters);
        }
    }
}

export default globalFilters;
